import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Statistics from './pages/Statistics';
import NFTs from './pages/NFTs';
import Map from './pages/Map';
import Notes from './pages/Notes';
import Terminal from './pages/Terminal';
import Documentation from './pages/Documentation';
import Settings from './pages/Settings';
import ImageGallery from './pages/ImageGallery';
import ViewUserNFT from './pages/ViewUserNFT';
import Login from './pages/Login';
import WebsiteSettings from './pages/WebsiteSettings';
import Articles from './pages/Articles';
import ArticleEditor from './pages/ArticleEditor';
import LandingPageEditor from './pages/LandingPageEditor';
import AppSettings from './pages/AppSettings';
import Gallery from './pages/Gallery';
import ChallengeGallery from './pages/ChallengeGallery';
import AdminManagement from './pages/AdminManagement';
import Events from './pages/Events';
import Rewards from './pages/Rewards';
import AuditLog from './pages/AuditLog';
import AdminTickets from './pages/AdminTickets';
import UserSupportTickets from './pages/UserSupportTickets';
import ChallengeStatistics from './pages/ChallengeStatistics';
// CartoonifyTest is now integrated into NFTs page as AI Cartoonify tab
// import CartoonifyTest from './pages/CartoonifyTest';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Public route for viewing user NFTs */}
      <Route path="/view-user-nfts" element={<ViewUserNFT />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/statistics/challenge/:challengeId" element={<ChallengeStatistics />} />
              <Route path="/nfts" element={<NFTs />} />
              {/* Redirect old cartoonify route to NFTs page with cartoonify tab */}
              <Route path="/cartoonify" element={<Navigate to="/nfts?tab=cartoonify" replace />} />
              <Route path="/map" element={<Map />} />
              <Route path="/challenge-gallery" element={<ChallengeGallery />} />
              <Route path="/events" element={<Events />} />
              <Route path="/rewards" element={<Rewards />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/admin-tickets" element={<AdminTickets />} />
              <Route path="/user-support" element={<UserSupportTickets />} />
              <Route path="/admin-management" element={<AdminManagement />} />
              <Route path="/terminal" element={<Terminal />} />
              <Route path="/activity-log" element={<AuditLog />} />
              <Route path="/website-settings" element={<WebsiteSettings />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/new" element={<ArticleEditor />} />
              <Route path="/articles/edit/:id" element={<ArticleEditor />} />
              <Route path="/landing-page" element={<LandingPageEditor />} />
              <Route path="/app-settings" element={<AppSettings />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/documentation" element={<Documentation />} />
              <Route path="/images" element={<ImageGallery />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;